import React, { useRef, useState } from "react";
import {
  IconChevronDown,
  IconChevronUp,
  IconEE,
  IconFI,
  IconLT,
  IconLV,
  TechnoramaIcon,
} from "../Layout/Icons";
import { ButtonRoundedSort } from "../buttons";
import { ShowCountries } from "../common/ButtonWithImumHistory";
import { AnimatePresence } from "framer-motion";
import { MdMergeType } from "react-icons/md";
import { imumMassNewPriceChangeByCountries } from "../../redux/Actions/imum_action";
import useOutsideAlerter from "../../hooks/useOutsideAlerter";

export default function ImumTdPreview({
  item,
  shorting,
  values,
  table_sort = {},
  setFilters = () => {},
  filter_recognition,
}) {
  const { countries } = values;

  const determineType = (type) => {
    switch (type) {
      case "Price change":
        return "change";
      case "New margin":
        return "margin";
      case "New price competitor":
        return "cheapest";
      case "Min market markup":
        return "min_market_margin";
      case "Min market price":
        return "cheapest_price";
      case "Cheapest competitor":
        return "cheapest_market";
      default:
        return "margin";
    }
  };

  if (item.lang && shorting) {
    // const active_lang = false;
    const its_type = determineType(item?.title);
    const its_active = () => {
      if (table_sort?.type !== its_type) return false;
      return table_sort?.lang;
    };
    const active_lang = its_active();
    return (
      <div className="d-flex">
        {countries.includes("LT") && (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              minWidth: 100,
              flex: 1,
            }}
          >
            <div className="d-flex justify-content-center align-items-center position-relative">
              {window.identifier == "technorama" ? (
                <TechnoramaIcon />
              ) : (
                <IconLT
                  active={true}
                  stroke={active_lang !== "LT" && "transparent"}
                />
              )}

              <div
                className="position-absolute"
                style={{
                  left: 19,
                }}
              >
                <ButtonRoundedSort
                  active={(active_lang == "LT" && table_sort?.sort) || ""}
                  setActive={(sort) => {
                    setFilters({
                      name: "table_sort",
                      value: {
                        ...table_sort,
                        lang: sort == "" ? "" : "LT",
                        sort,
                        type: sort == "" ? "" : its_type,
                      },
                    });
                  }}
                />
              </div>
            </div>
          </div>
        )}
        {countries.includes("LV") && (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              minWidth: 100,
              flex: 1,
            }}
          >
            <div className="d-flex justify-content-center align-items-center position-relative">
              <IconLV
                active={true}
                stroke={active_lang !== "LV" && "transparent"}
              />
              <div
                className="position-absolute"
                style={{
                  left: 19,
                }}
              >
                <ButtonRoundedSort
                  active={(active_lang == "LV" && table_sort?.sort) || ""}
                  setActive={(sort) => {
                    setFilters({
                      name: "table_sort",
                      value: {
                        ...table_sort,
                        lang: sort == "" ? "" : "LV",
                        sort,
                        type: sort == "" ? "" : its_type,
                      },
                    });
                  }}
                />
              </div>
            </div>
          </div>
        )}
        {countries.includes("EE") && (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              minWidth: 100,
              flex: 1,
            }}
          >
            <div className="d-flex justify-content-center align-items-center position-relative">
              <IconEE
                active={true}
                stroke={active_lang !== "EE" && "transparent"}
              />
              <div
                className="position-absolute"
                style={{
                  left: 19,
                }}
              >
                <ButtonRoundedSort
                  active={(active_lang == "EE" && table_sort?.sort) || ""}
                  setActive={(sort) => {
                    setFilters({
                      name: "table_sort",
                      value: {
                        ...table_sort,
                        lang: sort == "" ? "" : "EE",
                        sort,
                        type: sort == "" ? "" : its_type,
                      },
                    });
                  }}
                />
              </div>
            </div>
          </div>
        )}
        {countries.includes("FI") && (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              minWidth: 100,
              flex: 1,
            }}
          >
            <div className="d-flex justify-content-center align-items-center position-relative">
              <IconFI
                active={true}
                stroke={active_lang !== "FI" && "transparent"}
              />
              <div
                className="position-absolute"
                style={{
                  left: 19,
                }}
              >
                <ButtonRoundedSort
                  active={(active_lang == "FI" && table_sort?.sort) || ""}
                  setActive={(sort) => {
                    setFilters({
                      name: "table_sort",
                      value: {
                        ...table_sort,
                        lang: sort == "" ? "" : "FI",
                        sort,
                        type: sort == "" ? "" : its_type,
                      },
                    });
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
  if (item.lang) {
    return (
      <div className="d-flex">
        {countries.includes("LT") && (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              minWidth: 100,
              flex: 1,
            }}
          >
            {window.identifier == "technorama" ? (
              <TechnoramaIcon />
            ) : (
              <IconLT />
            )}
            {item.title == "New price" &&
              !!filter_recognition &&
              countries.length > 1 && (
                <MergeNewPrices
                  mainLang="LT"
                  filter_recognition={filter_recognition}
                />
              )}
          </div>
        )}
        {countries.includes("LV") && (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              minWidth: 100,
              flex: 1,
            }}
          >
            <IconLV />
            {item.title == "New price" && !!filter_recognition && (
              <MergeNewPrices
                mainLang="LV"
                filter_recognition={filter_recognition}
              />
            )}
          </div>
        )}
        {countries.includes("EE") && (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              minWidth: 100,
              flex: 1,
            }}
          >
            <IconEE />
            {item.title == "New price" && !!filter_recognition && (
              <MergeNewPrices
                mainLang="EE"
                filter_recognition={filter_recognition}
              />
            )}
          </div>
        )}
        {countries.includes("FI") && (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              minWidth: 100,
              flex: 1,
            }}
          >
            <IconFI />
            {item.title == "New price" && !!filter_recognition && (
              <MergeNewPrices
                mainLang="FI"
                filter_recognition={filter_recognition}
              />
            )}
          </div>
        )}
      </div>
    );
  }

  return item.title;
}

const MergeNewPrices = ({ mainLang, filter_recognition }) => {
  const wrapperRef = useRef(null);

  const [active, setActive] = useState(false);

  return (
    <div className="position-relative ml-1" ref={wrapperRef}>
      <div
        className="rounded-pill px-2 d-flex align-items-center justify-content-center py-1"
        style={{
          backgroundColor: active ? "#DEF5FE" : "rgba(217, 217, 217, 0.4)",
          // width: 30,
        }}
        onClick={() => setActive((prev) => !prev)}
      >
        <MdMergeType color={active ? "#03B0F7" : "#BFBFBF"} />
        {active ? (
          <IconChevronUp fill="#5F5F5F" />
        ) : (
          <IconChevronDown fill="#5F5F5F" />
        )}
      </div>
      <AnimatePresence>
        {active && (
          <ShowCountriesWrapper
            wrapperRef={wrapperRef}
            mergeLang={mainLang}
            setActive={setActive}
            onClick={(merge_to) => {
              imumMassNewPriceChangeByCountries(
                filter_recognition.filterString,
                {
                  merge_from: mainLang,
                  merge_to,
                  ids: filter_recognition.checked,
                }
              );
            }}
          />
        )}
      </AnimatePresence>
    </div>
  );
};

const ShowCountriesWrapper = ({
  wrapperRef,
  mergeLang,
  setActive,
  onClick,
}) => {
  useOutsideAlerter(wrapperRef, () => setActive(false));
  return (
    <ShowCountries
      mergeLang={mergeLang}
      setShowCountries={() => setActive(false)}
      onClick={onClick}
    />
  );
};
